import { SET_VARIABLE_OPS, type SetVariableOp } from "@velizhanin-dev/bot-scenario"
import { Field } from "@/shared/ui/form-field"
import { NativeSelect } from "@/shared/ui/native-select"
import { TextWithVariables } from "@/shared/ui/text-with-variables"
import { VariableSelect } from "@/shared/ui/variable-select"
import type { EditorProps } from "../editor-props"
import { readString, withField } from "../editor-props"
import { issuesAt } from "../issues-text"

const SET_OP_LABELS: Record<SetVariableOp, string> = {
	set: "Записать значение",
	increment: "Прибавить",
	clear: "Очистить",
}

export function SetVariableEditor({ config, onChange, issues, draft }: EditorProps) {
	const op = (readString(config, "op") || "set") as SetVariableOp
	return (
		<div className="space-y-4">
			<Field label="Переменная" issues={issuesAt(issues, "variable")}>
				<VariableSelect
					aria-label="Переменная"
					value={readString(config, "variable")}
					onChange={(variable) => onChange({ ...config, variable })}
					variables={draft.variables}
				/>
			</Field>
			<Field label="Действие" issues={issuesAt(issues, "op")}>
				<NativeSelect
					aria-label="Действие"
					value={op}
					onChange={(event) => {
						const next = event.target.value as SetVariableOp
						const base = { ...config, op: next }
						onChange(
							next === "clear"
								? withField(base, "value", undefined)
								: { ...base, value: readString(config, "value") },
						)
					}}
				>
					{SET_VARIABLE_OPS.map((value) => (
						<option key={value} value={value}>
							{SET_OP_LABELS[value]}
						</option>
					))}
				</NativeSelect>
			</Field>
			{op !== "clear" ? (
				<Field
					label={op === "increment" ? "Сколько прибавить" : "Значение"}
					hint={op === "increment" ? "Пусто: прибавить 1" : "Можно вставить другие переменные"}
					issues={issuesAt(issues, "value")}
				>
					<TextWithVariables
						multiline={false}
						value={readString(config, "value")}
						onChange={(value) => onChange({ ...config, value })}
						variables={draft.variables}
					/>
				</Field>
			) : null}
		</div>
	)
}
